export default __webpack_public_path__ + "static/media/undraw_checking_boxes_2ibd.90780d56.svg";